import React from 'react'
import Jobs from '../components/jobs'
export default function jobs() {
  return (
    <div>
        <Jobs/>
    </div>
  )
}
